import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Pricing = () => {
  return (
    <section id="pricing" className="py-24 bg-slate-900/50 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Transparent, High-ROI Pricing</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">One missed HVAC install or retainer covers the entire year. Test it risk-free.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Core Plan */}
          <div className="bg-slate-800 border-2 border-blue-500 rounded-3xl p-8 relative shadow-[0_0_30px_rgba(37,99,235,0.15)]">
            <div className="absolute top-0 right-8 transform -translate-y-1/2 bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-bold tracking-wide">
              MOST POPULAR
            </div>
            
            <h3 className="text-2xl font-bold text-white mb-2">AutoReception Core</h3>
            <div className="mb-6">
              <span className="text-5xl font-extrabold text-white">$699</span>
              <span className="text-slate-400"> / month</span>
            </div>
            <p className="text-sm text-blue-400 font-medium mb-8 bg-blue-500/10 inline-block px-3 py-1 rounded-lg">
              + $999 One-Time Setup Fee
            </p>

            <ul className="space-y-4 mb-8">
              {[
                "Includes 3-Day Free Trial",
                "24/7 AI Voice Phone Receptionist",
                "Instant Missed-Call Text-Back (<10s)",
                "Direct Calendar & CRM Integration",
                "Custom Knowledge Base & Call Routing",
                "Full Analytics Dashboard & Call Transcriptions",
                "No Long-Term Contracts (Cancel anytime)"
              ].map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <SafeIcon name="CheckCircle" className="text-emerald-400 text-xl shrink-0 mt-0.5" />
                  <span className="text-slate-300">{feature}</span>
                </li>
              ))}
            </ul>

            <a href="#contact" className="block w-full bg-blue-600 hover:bg-blue-500 text-white text-center py-4 rounded-xl font-bold text-lg transition-all shadow-[0_0_15px_rgba(37,99,235,0.4)]">
              Start 3-Day Free Trial
            </a>
          </div>

          {/* Add-on Plan */}
          <div className="bg-slate-800/50 border border-slate-700 rounded-3xl p-8 flex flex-col">
            <h3 className="text-2xl font-bold text-white mb-2">Website Receptionist Add-On</h3>
            <div className="mb-6">
              <span className="text-5xl font-extrabold text-white">+$99</span>
              <span className="text-slate-400"> / month</span>
            </div>
            <p className="text-sm text-slate-400 mb-8">
              Supercharge your website conversions.
            </p>

            <ul className="space-y-4 mb-8 flex-grow">
              {[
                "Embedded Website Voice & Chat Agent",
                "Captures online visitors on mobile & desktop",
                "Unified calendar sync",
                "Shared reporting dashboard"
              ].map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <SafeIcon name="Check" className="text-slate-400 text-xl shrink-0 mt-0.5" />
                  <span className="text-slate-300">{feature}</span>
                </li>
              ))}
            </ul>

            <a href="#contact" className="block w-full bg-slate-700 hover:bg-slate-600 text-white text-center py-4 rounded-xl font-bold text-lg transition-all">
              Add to Core Plan
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;